import { useSearchParams } from "../../../hooks/use_search_params";

export const ViewValues = ["list", "calendar"] as const;
export type ViewValuesType = (typeof ViewValues)[number];

export function useCalendarSearchParams() {
	return useSearchParams<{
		view: ViewValuesType;
		date: string;
	}>();
}
